/**
 * Checks if a value is a primitive type.
 * @param test - The value to be tested.
 * @returns `true` if the value is a primitive type, `false` otherwise.
 */
function isPrimitive(
    test: unknown,
): test is string | number | bigint | symbol | boolean {
    return (
        typeof test === "string" ||
        typeof test === "number" ||
        typeof test === "bigint" ||
        typeof test === "symbol" ||
        typeof test === "boolean"
    );
}

const isBoolean = (value: unknown): value is boolean => {
    return typeof value === "boolean";
};

type Primitive = string | number | bigint | symbol | boolean;
export { isBoolean, isPrimitive };
export type { Primitive };
